import React, {useState, createContext} from 'react'
export const BranchDetailsContext = createContext()
export const BranchDetailsProvider = (props) => {
    const[branchDetailsState, setBranchDetailsState] = useState({
        branchDetails: [],
        branchNames: [],
        branchIds: [],
        branchCities: [],
    })
    return (
        <BranchDetailsContext.Provider value={[branchDetailsState,setBranchDetailsState]}>
            {props.children}
        </BranchDetailsContext.Provider>
    )
}